/* @flow */

import avatarSizes from 'src/shared/ui/component/image/setting/avatarSizes';
import {
  xsmall,
  small,
  medium,
  large,
  xlarge,
  xxlarge,
} from 'src/shared/ui/component/image/setting/avatarVariants';

import type { AvatarVariant } from 'src/shared/ui/component/image/type/avatarTypes';

export function getAvatarSizeFromVariant(variant: AvatarVariant): ?number {
  let key;

  switch (variant) {
    case xsmall:
      key = 'xsmall';
      break;
    case small:
      key = 'small';
      break;
    case medium:
      key = 'medium';
      break;
    case large:
      key = 'large';
      break;
    case xlarge:
      key = 'xlarge';
      break;
    case xxlarge:
      key = 'xxlarge';
      break;
  }

  if (key) {
    return avatarSizes[key];
  }
}
